import { FILTER } from './constants';
var GREATER = FILTER.GREATER,
  LESS = FILTER.LESS,
  LESS_EQUAL = FILTER.LESS_EQUAL,
  GREATER_EQUAL = FILTER.GREATER_EQUAL,
  NOT_IN = FILTER.NOT_IN,
  IN = FILTER.IN,
  EQUAL = FILTER.EQUAL,
  NOT_LIKE = FILTER.NOT_LIKE,
  LIKE = FILTER.LIKE,
  REG_EXP = FILTER.REG_EXP,
  WILD_CARD = FILTER.WILD_CARD;
export var getOptionalStyleFilter = function getOptionalStyleFilter(style) {
  var options = {};
  if (style.hasOwnProperty('property')) {
    options.property = style.property;
  }
  if (style.hasOwnProperty('AND')) {
    options.AND = style.AND;
  }
  if (style.hasOwnProperty('OR')) {
    options.OR = style.OR;
  }
  return options;
};
export var filterOptionalStyle = function filterOptionalStyle(filter, feature) {
  var featProps = feature.getProperties();
  var AND = filter.AND,
    OR = filter.OR,
    property = filter.property;
  if (AND) {
    return AND.every(function (filter) {
      return filterProperty(filter, featProps[filter.key]);
    });
  }
  if (OR) {
    return !!OR.find(function (filter) {
      return filterProperty(filter, featProps[filter.key]);
    });
  }
  if (property) {
    return filterProperty(property, featProps[property.key]);
  }
  return false;
};

/**
 * @method: filterFeaturesByPropertyFilter
 * Filter the given array of  features based on the provided single property filter
 *
 * @param: {Objet} filter The filter object
 * @param: {array} features An array of oskari features (as opposed to ol features)
 */
export var filterFeaturesByPropertyFilter = function filterFeaturesByPropertyFilter(filter, features) {
  var _filter$property;
  var key = (filter === null || filter === void 0 || (_filter$property = filter.property) === null || _filter$property === void 0 ? void 0 : _filter$property.key) || null;
  if (!key || !features) {
    return null;
  }
  return features === null || features === void 0 ? void 0 : features.filter(function (feature) {
    if (Object.keys(feature === null || feature === void 0 ? void 0 : feature.properties).includes(key)) {
      return filterProperty(filter === null || filter === void 0 ? void 0 : filter.property, feature === null || feature === void 0 ? void 0 : feature.properties[key]);
    }
    return false;
  });
};
var filterProperty = function filterProperty(property, featValue) {
  if (!property.hasOwnProperty('key') || featValue === undefined) return false;
  var ignoreCase = property.caseSensitive !== true;
  if (property.hasOwnProperty(GREATER)) {
    // check if range
    if (property.hasOwnProperty(LESS)) {
      return featValue < property[LESS] && featValue > property[GREATER];
    } else if (property.hasOwnProperty(LESS_EQUAL)) {
      return featValue <= property[LESS_EQUAL] && featValue > property[GREATER];
    }
    return featValue > property[GREATER];
  }
  if (property.hasOwnProperty(GREATER_EQUAL)) {
    // check if range
    if (property.hasOwnProperty(LESS)) {
      return featValue < property[LESS] && featValue >= property[GREATER_EQUAL];
    } else if (property.hasOwnProperty(LESS_EQUAL)) {
      return featValue <= property[LESS_EQUAL] && featValue >= property[GREATER_EQUAL];
    }
    return featValue >= property[GREATER_EQUAL];
  }
  if (property.hasOwnProperty(LESS)) {
    return featValue < property[LESS];
  }
  if (property.hasOwnProperty(LESS_EQUAL)) {
    return featValue <= property[LESS_EQUAL];
  }
  if (property.hasOwnProperty(EQUAL)) {
    var styleValue = property[EQUAL];
    if (ignoreCase) {
      return String(styleValue).toLowerCase() === String(featValue).toLowerCase();
    }
    return styleValue === featValue;
  }
  if (property.hasOwnProperty(IN) || property.hasOwnProperty(NOT_IN)) {
    var not = property.hasOwnProperty(NOT_IN);
    var _styleValue = not ? property[NOT_IN] : property[IN];
    var match;
    if (Array.isArray(_styleValue)) {
      if (ignoreCase) {
        var strFeat = String(featValue).toLowerCase();
        match = _styleValue.map(function (v) {
          return String(v).toLowerCase();
        }).includes(strFeat);
      } else {
        match = _styleValue.includes(featValue);
      }
    } else if (ignoreCase) {
      match = String(_styleValue).toLowerCase() === String(featValue).toLowerCase();
    } else {
      match = _styleValue === featValue;
    }
    if (match === undefined) return false;
    return not ? !match : match;
  }
  if (property.hasOwnProperty(LIKE) || property.hasOwnProperty(NOT_LIKE)) {
    var _not = property.hasOwnProperty(NOT_LIKE);
    var strValue = ignoreCase ? String(featValue).toLowerCase() : String(featValue);
    var _styleValue2 = _not ? property[NOT_LIKE] : property[LIKE];
    var _match;
    if (ignoreCase) {
      _match = likeMatcher(strValue, String(_styleValue2).toLowerCase());
    } else {
      _match = likeMatcher(strValue, String(_styleValue2));
    }
    return _not ? !_match : _match;
  }
  if (property.hasOwnProperty(REG_EXP)) {
    var regexp = ignoreCase ? RegExp(property[REG_EXP], 'i') : RegExp(property[REG_EXP]);
    return regexp.test(featValue);
  }
  var ignoredOperators = Object.keys(property).filter(function (k) {
    return !(k === 'key' || k === 'caseSensitive');
  });
  if (ignoredOperators.length === 0) return false;
  Oskari.log('Oskari.mapping.mapmodule.oskariStyle').debug('Optional style has redundant keys: ' + ignoredOperators);
  return false;
};
var likeMatcher = function likeMatcher(featValue, like) {
  var endsWildCard = like.charAt(like.length - 1) === WILD_CARD;
  var startsWildCard = like.charAt(0) === WILD_CARD;
  var val;
  if (endsWildCard && startsWildCard) {
    val = like.substr(1, like.length - 2);
  } else if (endsWildCard) {
    val = like.substr(0, like.length - 2);
  } else if (startsWildCard) {
    val = like.substr(1);
  } else {
    Oskari.log('Oskari.mapping.mapmodule.oskariStyle').info('Optional style\'s filter like operator does not have wild card, use value operator instead');
    return false;
  }
  return featValue.includes(val);
};